import { StoreProps } from '@interfaces/StoreState'
import ContactUs from '@layouts/Support/ContactUs'
import ContactUsV2 from '@layouts/Support/ContactUs/v2'
import React from 'react'
import { useSelector } from 'react-redux'

const Contact: React.FC = () => {
  const useV2 = useSelector(({ permissions }: StoreProps) => permissions.permissions['flag::Support-ContactUsV2']?.show)
  return useV2 ? <ContactUsV2 /> : <ContactUs />
}

export default Contact
